package org.moxultimate.topwithmox.libraries.sample

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch
import org.moxultimate.topwithmox.core.base.ViewModel

/** UI state for the Koin DI demo screen. */
data class KoinSampleUiState(
    val greeting: String = "",
    val isLoading: Boolean = false,
    val error: String? = null,
)

/**
 * ViewModel for the Koin injection demo.
 *
 * [GreetingRepository] is injected by Koin via constructor — no manual wiring.
 * Registered as a `factory` in [org.moxultimate.topwithmox.di.SampleModule].
 *
 * @param repository injected automatically by Koin.
 */
class KoinSampleViewModel(
    private val repository: GreetingRepository,
) : ViewModel() {

    private val _uiState = MutableStateFlow(KoinSampleUiState())
    val uiState: StateFlow<KoinSampleUiState> = _uiState.asStateFlow()

    /** Fetches a greeting for [name] via the injected [repository]. */
    fun greet(name: String) {
        if (name.isBlank()) {
            _uiState.update { it.copy(error = "Name cannot be empty") }
            return
        }
        viewModelScope.launch {
            _uiState.update { it.copy(isLoading = true, error = null) }
            try {
                val message = repository.greet(name)
                _uiState.update { it.copy(greeting = message, isLoading = false) }
            } catch (e: Exception) {
                _uiState.update { it.copy(error = e.message, isLoading = false) }
            }
        }
    }
}
